export class OrdMsg {
  ordMsgId: number;
  epmsOrderId: string;
  message: string;
  createdBy: string;
  createdTimestamp: number;
}
